import { IDataState } from '../../types/app-state'
import {
  FETCHING_STATES,
  FETCHING_NEWS,
  ERROR_NEWS,
  UPDATE_NEWS,
  FETCHING_GROUPS,
  ERROR_GROUPS,
  UPDATE_GROUPS,
  FETCHING_MATCHES,
  ERROR_MATCHES,
  UPDATE_MATCHES,
  FETCHING_CLIPS_AND_PLAYLISTS,
  ERROR_CLIPS_AND_PLAYLISTS,
  UPDATE_CLIPS_AND_PLAYLISTS,
  FETCHING_SCHEDULE,
  ERROR_SCHEDULE,
  UPDATE_SCHEDULE,
  FETCHING_MATCH_CLIPS,
  ERROR_MATCH_CLIPS,
  UPDATE_MATCH_CLIPS
} from '../constants/data'
const { READY, FETCHING, ERROR } = FETCHING_STATES

const initialState: IDataState = {
  news: {
    data: {
      topScorers: [],
      topRedCards: [],
      topYellowCards: [],
      flow: [],
      universe: [],
      newsFeed: {
        title: '',
        items: []
      }
    },
    lastUpdated: new Date(),
    status: FETCHING_STATES.READY
  },
  schedule: {
    data: [],
    lastUpdated: new Date(),
    status: READY
  },
  matches: {},
  groups: { data: [], lastUpdated: new Date(), status: READY },
  playlists: {
    data: [],
    lastUpdated: new Date(),
    status: FETCHING_STATES.READY
  },
  clips: {
    data: [],
    lastUpdated: new Date(),
    status: FETCHING_STATES.READY
  },
  matchesClips: {}
}

const reducer = (state = initialState, action): IDataState => {
  switch (action.type) {
    case FETCHING_NEWS:
      return {
        ...state,
        news: {
          ...state.news,
          status: FETCHING
        }
      }
    case ERROR_NEWS:
      return {
        ...state,
        news: {
          ...state.news,
          status: ERROR
        }
      }
    case UPDATE_NEWS:
      return {
        ...state,
        news: {
          lastUpdated: new Date(),
          status: READY,
          data: action.news
        }
      }
    case FETCHING_GROUPS:
      return {
        ...state,
        groups: {
          ...state.groups,
          status: FETCHING
        }
      }
    case ERROR_GROUPS:
      return {
        ...state,
        groups: {
          ...state.groups,
          status: ERROR
        }
      }
    case UPDATE_GROUPS:
      return {
        ...state,
        groups: {
          lastUpdated: new Date(),
          status: READY,
          data: action.groups
        }
      }
    case FETCHING_MATCHES:
      return {
        ...state,
        matches: {
          ...state.matches,
          [action.id]: {
            ...state.matches[action.id],
            status: FETCHING
          }
        }
      }
    case ERROR_MATCHES:
      return {
        ...state,
        matches: {
          ...state.matches,
          [action.id]: {
            ...state.matches[action.id],
            status: ERROR
          }
        }
      }
    case UPDATE_MATCHES:
      return {
        ...state,
        matches: {
          ...state.matches,
          [action.id]: {
            data: action.match,
            lastUpdated: new Date(),
            status: READY
          }
        }
      }
    case FETCHING_CLIPS_AND_PLAYLISTS:
      return {
        ...state,
        playlists: {
          ...state.playlists,
          status: FETCHING_STATES.FETCHING
        }
      }
    case ERROR_CLIPS_AND_PLAYLISTS:
      return {
        ...state,
        clips: {
          ...state.clips,
          status: FETCHING_STATES.ERROR
        },
        playlists: {
          ...state.playlists,
          status: FETCHING_STATES.ERROR
        }
      }
    case UPDATE_CLIPS_AND_PLAYLISTS:
      return {
        ...state,
        clips: {
          lastUpdated: new Date(),
          status: FETCHING_STATES.READY,
          data: action.clips
        },
        playlists: {
          lastUpdated: new Date(),
          status: FETCHING_STATES.READY,
          data: action.playlists
        }
      }
    case FETCHING_SCHEDULE:
      return {
        ...state,
        schedule: {
          ...state.schedule,
          status: FETCHING
        }
      }
    case ERROR_SCHEDULE:
      return {
        ...state,
        schedule: {
          ...state.schedule,
          status: ERROR
        }
      }
    case UPDATE_SCHEDULE:
      return {
        ...state,
        schedule: {
          lastUpdated: new Date(),
          status: READY,
          data: action.data.length ? action.data : state.schedule.data
        }
      }
    case FETCHING_MATCH_CLIPS:
      return {
        ...state,
        matchesClips: {
          ...state.matchesClips,
          [action.id]: {
            ...state.matchesClips[action.id],
            status: FETCHING
          }
        }
      }
    case FETCHING_MATCH_CLIPS:
      return {
        ...state,
        matchesClips: {
          ...state.matchesClips,
          [action.id]: {
            ...state.matchesClips[action.id],
            status: ERROR
          }
        }
      }
    case FETCHING_MATCH_CLIPS:
      return {
        ...state,
        matchesClips: {
          ...state.matchesClips,
          [action.id]: {
            data: action.matchClip,
            lastUpdated: new Date(),
            status: READY
          }
        }
      }
    default:
      return state
  }
}

export { reducer }
